import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { WEBAPP_HOST } from 'Config/constants';
import PrerenderMetaRedirect from 'components/Prerender/PrerenderMetaRedirect';
import isPrerenderCrawler from 'helpers/isPrerenderCrawler';

const PublisherProfileForeignPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const isPrerender = isPrerenderCrawler();
  const history = useHistory();

  useEffect(() => {
    if (!isPrerender && slug) {
      history.replace(`/${slug}`);
    }
  }, [isPrerender, slug, history]);

  if (isPrerender) {
    return (
      <PrerenderMetaRedirect
        to={`${WEBAPP_HOST}/${slug}`}
        status="moved_permanently"
      />
    );
  }

  return null;
};

export default PublisherProfileForeignPage;
